import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ChildViewStore, for use in the registry */ export const ChildViewStoreActionTypes = [
    ActionType.UpdateChildViewStatusAction
];
